import { useEffect } from 'react';
import { Navigate } from 'react-router';
import { useAuthState } from '#features/auth/state';
import { useConfiguration } from '#features/configuration/state';
import { ImpersonateForm } from '#features/impersonation/ImpersonateForm';
import { withSubscribe } from '#lib/withSubscribe';
import { buildLandingPageUrl } from '#services/auth/landing-page';
import { isLoggedIn, isLogoutInProgress } from '#services/auth/model';

const LogonPageComponent = () => {
  const authState = useAuthState();
  const configuration = useConfiguration();

  useEffect(() => {
    if (isLogoutInProgress(authState)) {
      window.location.href = configuration.authentication.ssoLogoutUrl;
      return;
    }

    // automatically redirect to SSO when impersonation is disabled
    if (!configuration.authentication.impersonate) {
      window.location.href = buildLandingPageUrl(
        configuration.authentication.landingPageUrl,
      );
    }
  }, [
    authState,
    configuration.authentication.impersonate,
    configuration.authentication.landingPageUrl,
    configuration.authentication.ssoLogoutUrl,
  ]);

  if (isLoggedIn(authState)) {
    return <Navigate to="/" replace />;
  }

  if (isLogoutInProgress(authState)) {
    return null;
  }

  if (configuration.authentication.impersonate) {
    return (
      <ImpersonateForm
        landingPageUrl={configuration.authentication.landingPageUrl}
      />
    );
  }

  return null;
};

export const LogonPage = withSubscribe(LogonPageComponent);
